import { ReactNode } from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import styles from './app-modal.module.css';

export default function AppModal({
  show,
  onClose,
  icon,
  title,
  children,
  cancelLabel = 'Cancel',
  primaryLabel,
  onPrimary,
  primaryDisabled,
  primaryDanger,
  extraButtons,
  size,
  className,
}: {
  show: boolean;
  onClose: () => void;
  icon: IconDefinition;
  title: ReactNode;
  children: ReactNode;
  cancelLabel?: string;
  primaryLabel?: ReactNode;
  onPrimary?: () => void;
  primaryDisabled?: boolean;
  primaryDanger?: boolean;
  extraButtons?: ReactNode;
  size?: 'sm' | 'lg' | 'xl';
  className?: string;
}) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size={size}
      className={className}
      contentClassName={styles.content}
    >
      <Modal.Header>
        <Modal.Title
          style={{ fontSize: 14, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}
        >
          <FontAwesomeIcon icon={icon} />
          {title}
        </Modal.Title>
        <button
          type="button"
          className="btn btn-sm text-muted"
          style={{ marginLeft: 'auto' }}
          onClick={onClose}
          title="Close"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <button type="button" className={`btn btn-sm ${styles.cancelButton}`} onClick={onClose}>
          {cancelLabel}
        </button>
        {primaryLabel !== undefined && (
          <button
            type="button"
            className={`btn btn-sm ${primaryDanger ? 'btn-danger' : styles.primaryButton}`}
            disabled={primaryDisabled}
            onClick={onPrimary}
          >
            {primaryLabel}
          </button>
        )}
        {extraButtons}
      </Modal.Footer>
    </Modal>
  );
}
